<template lang="pug">
  v-layout(align-start)
    v-flex
      v-data-table.elevation-1(:headers='headers' item-key='pedidos' :items='pedidos' :search='search' sort-by='numeroPedido' :loading='loading' loading-text='Cargando, por favor espere...')
        template(v-slot:top)
          v-toolbar(flat color='primary' dark)
            v-toolbar-title Facturas
            v-divider.mx-4(inset vertical)
            v-spacer
            v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line hide-details color='success')
            v-spacer
            v-dialog(v-model='dialog' scrollable persistent max-width='80%')
              template(v-slot:activator='{ on }')
                v-btn.mx-2(fab dark small color='success' v-on='on')
                  v-icon(dark) mdi-plus
              v-card(color='grey_1')
                v-app-bar(dark color='primary')
                  v-toolbar-title.headline {{ formTitle }}
                v-divider(light)
                v-card-text
                  v-row(dense)
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense v-if="editedIndex === -1")
                            v-col(cols='12' xs='12' sm='4')
                              v-autocomplete(:menu-props="{closeOnContentClick: true}" autocomplete="off" dense outlined :readonly='read' v-model='editedItem.idCliente' :items='clientes' label='Cliente')
                                template(v-slot:prepend-item v-if="validarModificarCli()")
                                  v-list(dense)
                                    v-list-item( @click='emp = true')
                                      v-list-item-avatar(color='grey_1' small)
                                        v-btn.mx-2(fab dark x-small color='success')
                                          v-icon(dark small) mdi-plus
                                      v-list-item-content
                                        v-list-item-title
                                          | Agregar Cliente
                            ClienteM(:dialog='emp' :editedIndex='-1' @close='emp = false' @save='listarClientes')
                            v-col(cols='12' xs='12' sm='4')
                              v-dialog(ref='dialog2' v-model='modalCre' :return-value.sync='date' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='editedItem.fechaCreacion' label='Fecha de creación' prepend-inner-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='editedItem.fechaCreacion' locale="ES" )
                                  v-spacer
                                  v-btn(small dark color='red' @click='modalCre = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog2.save(date)') Ok
                            v-col(cols='12' xs='12' sm='4')
                              v-dialog(ref='dialog1' v-model='modalven' :return-value.sync='date' readonly persistent width='300px')
                                template(v-slot:activator='{ on }')
                                  v-text-field( v-model='editedItem.fechaVencimiento' label='Fecha de vencimiento' prepend-inner-icon='event' readonly dense outlined v-on='on')
                                v-date-picker( v-model='editedItem.fechaVencimiento' locale="ES" )
                                  v-spacer
                                  v-btn(small dark color='red' @click='modalven = false') Cancelar
                                  v-btn(small dark color='success' @click='$refs.dialog1.save(date)') Ok
                            v-col(cols='12' xs='12' sm='6')
                              v-select(dense outlined v-model='editedItem.tipoVenta' :items='items', label='Tipo de Venta')
                            v-col(cols='12' xs='12' sm='6')
                              v-select(dense outlined, v-model='editedItem.formaPago', :items='formaPago', label='Forma de pago')                            v-col(cols='12' sm='12' md='12')
                          v-row(dense v-if="editedIndex === -1")
                            v-textarea(auto-grow, v-model='editedItem.observacion', :readonly='read', label="Observación", outlined, dense, v-uppercase)
                          v-row(dense v-else)
                            v-col(cols='4' sm='4' md='4')
                              v-text-field(dense readonly outlined v-model='editedItem.idPedido.idCliente.nombre'  label='Cliente')
                            v-col(cols='4' sm='4' md='4')
                              v-select(dense outlined readonly v-model='editedItem.tipoVenta', :items='items', label='Tipo de Venta')
                            v-col(cols='4' sm='4' md='4')
                              v-text-field( v-model='editedItem.fechaVencimiento' label='Fecha de vencimiento' prepend-icon='event' readonly dense outlined)
                            v-col(cols='12' sm='12' md='12')
                              v-textarea(auto-grow v-model='editedItem.observacion' :readonly='read' label="Observación" outlined dense)
                    //- PRODUCTOS_A_SELECCIONAR
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosParaVenta(:read='read' :loading='loadinghijo' :consignado='consignado' :productosParaVenta='productosParaVenta' @agregarAlCarrito='agregarAlCarrito')
                    v-col(cols='12')
                      v-card(color='white')
                        v-card-text
                          v-row(dense)
                            v-col(cols='12' sm='12' md='12')
                              ProductosCargados(:read='read' :productosEnCarrito='editedItem.detalleProducto' @modificarCarrito='modificarCarrito' @quitarCarrito='quitarCarrito')
                          p
                          v-row(dense)
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.gravado | read'  label='IVA')
                            v-col(cols='12' sm='12' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.subTotal | read' label='Subtotal')
                            v-col(cols='8' sm='8' md='4')
                              v-text-field(dense readonly outlined :value='editedItem.total | read' label='Total + IVA')
                v-card-actions
                  v-spacer
                  v-btn(color='error' small dark @click='close')
                    v-icon mdi-close
                    | Cancelar
                  v-btn(v-if="!read" color='success' small dark @click='save')
                    v-icon mdi-content-save
                    | Guardar
        template(v-slot:item.action='{ item }')
          v-tooltip(bottom='')
            template(v-slot:activator='{ on }')
              v-icon.mr-2(color='primary_2' @click='editItem(item,true)' v-on="on") mdi-eye
            | Visualizar
        template(v-slot:no-data)
          h1 No hay pedidos de compras asociadas
      FacturaDirecta(:dialogFacturaDirecta='dialogFacturaDirecta' @close = 'closeF')
</template>

<script>
import Api from '@/services/methods'
import ProductosCargados from '../components/ProductosCargados'
import ProductosParaVenta from '../components/ProductosParaVenta'
import ClienteM from '../components/modals/ClienteM'
import { EventBus } from '../Events'
import FacturaDirecta from '../components/reportes/FacturaDirecta'
export default {
  data: () => ({
    dialogFacturaDirecta: false,
    date: new Date().toISOString().substr(0, 10),
    modalven: false,
    modalCre: false,
    consignado: false,
    dialog: false,
    read: false,
    boton: false,
    emp: false,
    items: ['Credito', 'Al Contado'],
    formaPago: ['Efectivo', 'Tarjeta', 'Transferencia', 'Otro'],
    loading: true,
    loadinghijo: true,
    headers: [
      { text: 'Factura', align: 'center', value: 'numFactura' },
      { text: 'Cliente', align: 'center', value: 'idPedido.idCliente.nombre' },
      { text: 'Fecha de creación', align: 'center', value: 'fechaCreacion' },
      { text: 'Fecha de vencimiento', align: 'center', value: 'fechaVencimiento'},
      { text: 'Monto Total', align: 'center', value: 'total' },
      { text: 'Tipo de Venta', align: 'center', value: 'tipoVenta' },
      { text: 'Estatus', align: 'center', value: 'estatus' },
      { text: 'Acciones', value: 'action', align: 'center', sortable: false }
    ],
    search: '',
    permisosCliente: {},
    permisosRuta: {},
    pedidos: [],
    clientes: [],
    productosParaVenta: [],
    editedIndex: -1,
    nombreUsuario: '',
    editedItem: {
      idCliente: '',
      numFactura: null,
      tipoVenta: null,
      numControl: null,
      detalleProducto: [],
      idEmpresa: [],
      subTotal: 0,
      gravado: 0,
      total: 0,
      formaPago: '',
      idPedido: null,
      numeroPedido: null,
      observacion: null,
      fechaCreacion: '',
      fechaVencimiento: '',
      exento: 0,
      debito: 0,
      credito: 0
    },
    defaultItem: {
      idCliente: '',
      numFactura: null,
      tipoVenta: null,
      numControl: null,
      detalleProducto: [],
      idEmpresa: [],
      subTotal: 0,
      gravado: 0,
      total: 0,
      formaPago: '',
      idPedido: null,
      numeroPedido: null,
      observacion: null,
      fechaCreacion: '',
      fechaVencimiento: '',
      exento: 0,
      debito: 0,
      credito: 0
    }
  }),

  components: {
    ProductosCargados,
    ProductosParaVenta,
    ClienteM,
    FacturaDirecta
  },

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Nueva Factura'
        : this.read
          ? 'Informacion de la Factura'
          : 'Modificar Factura'
    },
    formTitleShow () {
      return 'Información del Pedido'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    }
  },

  created () {
    this.initialize()
    this.permisosCliente = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'Cliente'
    )
    this.permisosRuta = this.$store.state.empresa[0].permisos.find(
      permiso => permiso.ruta === 'FacturaPedido'
    )
  },

  mounted () {
    this.consignado = true
  },

  methods: {
    initialize () {
      this.listarVentas()
      this.listarClientes()
      this.listarProductoParaVenta()
      this.buscarUsuario()
      this.cargarEmpresa(this.$store.state.empresa[0].idEmpresa._id)
    },

    listarVentas () {
      Api.get('/venta')
        .then(response => {
          this.pedidos = response.data
          this.pedidos.map(data => {
            data.fechaCreacion = this.formato(data.fechaCreacion)
            data.fechaVencimiento = this.formato(data.fechaVencimiento)
            data.total = (data.total).toFixed(2)
          })
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarClientes () {
      Api.get('cliente')
        .then(res => {
          res.data.forEach(cliente => {
            this.clientes.push({
              text: cliente.nombre,
              value: {
                _id: cliente._id,
                nombre: cliente.nombre,
                rif: cliente.rif,
                direccion: cliente.direccion,
                telefono: cliente.telefono,
                ciudad: cliente.ciudad,
                codEstado: cliente.codEstado
              }
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    listarProductoParaVenta () {
      Api.get('proalma/soloventa')
        .then(res => {
          this.productosParaVenta = res.data
          this.loadinghijo = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    buscarUsuario () {
      Api.get('usuario', this.$store.state.usuario._id)
        .then(res => {
          this.nombreUsuario = res.data[0].nombre
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    cargarEmpresa (id) {
      Api.get(`empresa/${id}`).then(response => {
        this.editedItem.idEmpresa = response.data
      })
    },

    formato (fecha) {
      return this.$moment(fecha).format('YYYY-MM-DD, HH:mm')
    },

    functionBs (val) {
      return 'BsS ' + Number.parseFloat(val).toFixed(2)
    },

    actualizarMontosTotales () {
      // me actualizar los montos totales cuando se agrega un producto
      this.editedItem.subTotal = 0
      this.editedItem.gravado = 0
      this.editedItem.exento = 0
      this.editedItem.baseImponible = 0
      this.editedItem.total = 0
      if (this.editedItem.detalleProducto.length > 0) {
        this.editedItem.detalleProducto.map(data => {
          this.editedItem.subTotal += data.subTotal
          this.editedItem.gravado += data.gravado
          this.editedItem.exento += data.exento
          this.editedItem.baseImponible += data.baseImponible
        })
        this.editedItem.total = Math.round((this.editedItem.subTotal + this.editedItem.gravado) * 100) / 100
      }
    },

    agregarAlCarrito (item) {
      this.boton = true
      const indexVenta = this.productosParaVenta.findIndex(
        prod => prod.idProducto === item.idProducto
      )
      const indexCarrito = this.editedItem.detalleProducto.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )
      if (indexCarrito > -1) {
        this.editedItem.detalleProducto[indexCarrito].cantidadSolicitada +=
          item.cantidadSolicitada
        this.editedItem.detalleProducto[indexCarrito].total += item.total
        this.editedItem.detalleProducto[indexCarrito].total =
          Math.round(
            this.editedItem.detalleProducto[indexCarrito].total * 100
          ) / 100
        this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      } else {
        this.editedItem.detalleProducto.push(item)
      }
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.actualizarMontosTotales()
    },

    modificarCarrito (item) {
      const indexVenta = this.productosParaVenta.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )
      item.cantidad = this.productosParaVenta[indexVenta].cantidad
      let producto = Object.assign({}, item)
      let suma = item.cantidad + item.cantidadSolicitada
      if (producto.cantidadSolicitadaAux > suma) {
        this.$swal({
          icon: 'error',
          title: 'La cantidad solicitada es mayor al stock',
          text: `cantidad solicitada: ${
            producto.cantidadSolicitadaAux
          }, cantidad en stock: ${suma}`
        })
      } else {
        if (producto.cantidadSolicitadaAux < producto.cantidadSolicitada) {
          let dif =
            producto.cantidadSolicitada - producto.cantidadSolicitadaAux
          producto.cantidad += dif
          producto.cantidadSolicitada = producto.cantidadSolicitadaAux
        } else if (
          producto.cantidadSolicitadaAux === producto.cantidadSolicitada
        ) {
        } else {
          producto.cantidad -=
            producto.cantidadSolicitadaAux - producto.cantidadSolicitada
          producto.cantidadSolicitada = parseInt(producto.cantidadSolicitada)
        }
      }

      const indexCarrito = this.editedItem.detalleProducto.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )

      Object.assign(this.editedItem.detalleProducto[indexCarrito], producto)
      Object.assign(this.productosParaVenta[indexVenta], item)
      this.editedItem.detalleProducto = [...this.editedItem.detalleProducto]
      this.productosParaVenta = [...this.productosParaVenta]
      this.actualizarMontosTotales()
    },

    quitarCarrito (item) {
      const pos = this.editedItem.detalleProducto.indexOf(item)
      const indexVenta = this.productosParaVenta.findIndex(
        prod => prod.idProducto._id === item.idProducto._id
      )
      this.editedItem.detalleProducto.splice(pos, 1)
      this.productosParaVenta[indexVenta].cantidad += item.cantidadSolicitada
      this.actualizarMontosTotales()
      if (this.editedItem.detalleProducto.length > 0) this.boton = false
    },

    validarCrear () {
      return true
      // return this.permisosRuta.accion.includes("Crear");
    },
    validarModificar () {
      return true
      // return this.permisosRuta.accion.includes("Modificar");
    },
    validarEliminar () {
      return true
      // return this.permisosRuta.accion.includes("Eliminar");
    },
    validarModificarCli () {
      return this.permisosCliente?.accion.includes('Crear')
    },

    editItem (item, bool) {
      this.editedIndex = this.pedidos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
      this.read = bool
      this.editedItem.detalleProducto.map(prod => {
        prod.cantidadSolicitada = prod.despachada
      })
      // this.boton = !bool
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.productosParaVenta = []
        this.loadinghijo = true
        this.editedItem = Object.assign({}, this.defaultItem)
        // this.editedItem.detalleProducto = []
        this.editedIndex = -1
        this.read = false
        this.boton = false
        this.listarProductoParaVenta()
      }, 300)
    },

    closeF () {
      this.dialogFacturaDirecta = false
    },

    validarCampos () {
      if (this.editedItem.idCliente === '') {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      } else if (this.editedItem.total === 0) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor debe agregar productos a la factura'
        })
        return true
      } else if ( this.$moment(this.editedItem.fechaVencimiento) < this.$moment(this.editedItem.fechaCreacion) ) {
        this.$swal({
          icon: 'error',
          title: 'Error en las fechas!',
          text:
            'La Fecha de Vencimiento no puede ser menor a la Fecha de Creación. Por favor, verifique'
        })
        this.editedItem.fechaVencimiento = ''
        this.editedItem.fechaCreacion = ''
        return true
      }
      return false
    },

    validaProductos () {
      if (this.editedItem.detalleProducto.length <= 0) {
        this.$swal({
          icon: 'error',
          title: 'No existen productos cargados',
          text: 'Carge productos para emitir el pedido'
        })
        return true
      }
      return false
    },

    imprimirFactura (numFactura) {
      const cedula =
        this.editedItem.idCliente.rif.length === 11
          ? this.editedItem.idCliente.rif.substr(2, 8)
          : this.editedItem.idCliente.rif.substr(2)
      const peticion = {
        cedula: cedula,
        nombre: this.editedItem.idCliente.nombre,
        direcion: this.editedItem.idCliente.direccion,
        numeroFactura: numFactura,
        unidadesVendidas:
          this.editedItem.detalleProducto.length === 1
            ? this.editedItem.detalleProducto[0].cantidadSolicitada
            : this.editedItem.detalleProducto.reduce(
              (a, b) => a.cantidadSolicitada + b.cantidadSolicitada
            ),
        formaPago: this.editedItem.formaPago,
        condicionPago: this.editedItem.tipoVenta,
        productos: this.editedItem.detalleProducto.map(producto => {
          return {
            descripcion: producto.idProducto.descripcion,
            codigo: producto.idProducto.nombre,
            cantidad: parseFloat(producto.cantidadSolicitada),
            bsSinIVA: producto.subTotal || null,
            bsConIVA: producto.total || null,
            exento: producto.idIva.valor === 0,
            unidadMedida: producto.idProducto.unidadMedida?.descripcion
          }
        }),
        total: this.editedItem.total
      }

      this.$swal({
        title: 'Imprimiendo...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })

      // ruta para imprimir
      Api.get(`${this.$store.state.ipMaquina}`, peticion)
        .then(res => {
          this.$swal({
            icon: 'success',
            title: 'Impresion exitosa'
          })
          this.close()
          this.initialize()
        })
        .catch(err => {
          console.log(err)
          this.$swal({
            icon: 'error',
            title: 'Error al imprimir',
            text: 'Por favor, verifique los datos e intente de nuevo'
          })
          this.close()
          this.initialize()
        })
    },

    save () {
      if (!this.validarCampos() && !this.validaProductos()) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })
        this.editedItem.debito = 0
        this.editedItem.credito = this.editedItem.total
        Api.post('venta/minorista', this.editedItem)
          .then(res => {
            this.editedItem.numFactura = res.data.numFactura
            this.editedItem.numControl = res.data.numControl
            this.$swal({
              icon: 'success',
              title: 'Inclusion exitosa',
              text: 'Todos los datos han sido guardados'
            })
            if (this.$store.state.ipMaquina !== '') {
              this.imprimirFactura(res.data.numFactura)
            } else {
              let array = {
                editedItem: this.editedItem,
                nombreUsuario: this.nombreUsuario
              }
              // Bus a FacturaDirecta.vue
              EventBus.$emit('dataFacturaDirecta', array)
              this.dialogFacturaDirecta = true
              this.close()
              this.initialize()
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al guardar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  }
}
</script>
